module.exports = __webpack_public_path__ + "static/img/solution_intel_bg.755c7547.png";